import {Component, h} from 'preact'
import {BulkAction} from '../index'
import {getIdAndContentTypeFromTopics, performBulkActionForTopics} from './utils'

import DynamicModeratorList from "../../list-selector/DynamicModeratorList";
import {User} from "../../user-selector/User";
import axios from 'axios'
import {UserListItem} from "../../list-selector/UserList";
import Icon from "../../assets";

export const assignModerator = () => ({
    Component: ({numberOfSelectedTopics, performBulkAction}: { numberOfSelectedTopics: number, performBulkAction: (bulkAction: BulkAction) => void }) =>
        <AssignModerator numberOfSelectedTopics={numberOfSelectedTopics} performBulkAction={performBulkAction}/>
})

type Props = {
    performBulkAction: (bulkAction: BulkAction) => void,
    numberOfSelectedTopics: number
}
type State = {
    isModalOpen: boolean
}

class AssignModerator extends Component<Props, State> {

    constructor() {
        super()
        this.state = {
            isModalOpen: false
        }
    }

    assign = async (user: User) => {
        const {performBulkAction, numberOfSelectedTopics} = this.props

        const bulkAction = {
            successMessage: `${numberOfSelectedTopics} topic(s) assigned to ${user.name}`,
            onClick: async (selectedTopics: any) => axios.post(`/community/api/bulk/process?moderatorId=${window.inSidedData.user.userid}`, {
                'action': 'assignModerator',
                'topics': getIdAndContentTypeFromTopics(selectedTopics),
                'params': {
                    assignedTo: Number(user.id)
                }
            })
        }

        performBulkAction(bulkAction)
    }

    unassign = async () => {
        const {performBulkAction, numberOfSelectedTopics} = this.props

        const bulkAction = {
            successMessage: `${numberOfSelectedTopics} topic(s) unassigned`,
            onClick: async (selectedTopics: any) => performBulkActionForTopics(selectedTopics, 'unassignModerator'),
        }

        performBulkAction(bulkAction)
    }

    render({performBulkAction}: Props, {}: State) {
        return <DynamicModeratorList
            align={'right'}
            buttonTitle={<div><Icon icon='person' width={16} height={16} />Assign moderator</div>}
            header={(close) =>
                <Buttons assignToMe={() => this.assign({
                    id: window.inSidedData.user.userid,
                    name: window.inSidedData.user.name
                })} unassign={this.unassign}/>}
            onUserClick={this.assign}
            newStyle={true}
        />

    }
}

const Buttons = ({assignToMe, unassign}: { assignToMe: () => void, unassign: () => void }) => {
    return <div class={'bulk-actions-assign-moderator-buttons'}>
        <UserListItem user={{id: '', name: 'Unassign'}} onClick={unassign} customIcon={'user'}/>
        <UserListItem user={{
            id: window.inSidedData.user.userid,
            name: window.inSidedData.user.name + ' (assign to me)',
            avatar: window.inSidedData.user.avatar
        }} onClick={assignToMe}/>
    </div>
}
